<div class="container-wrapper">
    <div class="content-wrapper">
        <app-level-of-detail
                [useCaseDetails]="useCaseDetails"
                [consentUseCaseValues]="consentUseCaseValues"
                [defaultLevels]="defaultUnitALevels"
                [provisionDurationValues]="provisionDurationValues"
                [provisionDuration]="provisionDuration"
                [durationInMillis]="durationInMillis"
                (sliderChangeEvent)="sliderChange($event)"
                (relevanceChangeEvent)="relevanceChange($event)">
        </app-level-of-detail>
    </div>
    <div class="btn-wrapper">
        <app-button
                [tabindex]="2"
                [cssClasses]="'btn regular full-width solid__blue-07'"
                [ariaLabel]="('ONBOARDING.USE_CASE_LEVELS.BUTTON' | translate) + ('SCREEN_READER.TAB_BUTTON' | translate)"
                (buttonClicked)="nextStepClick()">
            {{'ONBOARDING.USE_CASE_LEVELS.BUTTON' | translate }}
        </app-button>
    </div>
</div>
